import { render, staticRenderFns } from "./third.vue?vue&type=template&id=1b66d8d8&scoped=true&"
import script from "./third.vue?vue&type=script&lang=js&"
export * from "./third.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b66d8d8",
  null
  
)

export default component.exports